// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2ngii","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2QW1E"};